module.exports = __webpack_public_path__ + "001-pj/assets/images/svg/logo_light.svg";